import React from 'react';

import { createStyles, Title, Text, Button, Container, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const useStyles = createStyles(theme => ({
  root: {
    paddingTop: 80,
    paddingBottom: 80,
  },

  label: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
    color: theme.colors.gray[2],

    [theme.fn.smallerThan('sm')]: {
      fontSize: 120,
    },
  },

  title: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 38,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 32,
    },
  },

  description: {
    maxWidth: 500,
    margin: 'auto',
    marginTop: theme.spacing.xl,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
  },
}));

const SocialLoginError = (): JSX.Element => {
  const navigate = useNavigate();
  const { classes } = useStyles();

  const handleGoLogin = (): void => {
    navigate('/login');
  };

  const handleOnGoBack = (): void => {
    navigate(-1);
  };

  return (
    <Container className={classes.root}>
      <div className={classes.label}>Error</div>
      <Title className={classes.title}>Social Login Failed.</Title>
      <Text color='dimmed' size='lg' align='center' className={classes.description}>
        There was an error attempting social login. Please make sure your Google/Facebook/Apple email matches
        your Kilo email. If you are trying to login please make sure your account is activated. If you are
        using Apple please be sure to share your email with Kilo.
      </Text>
      <Group position='center'>
        <Button variant='subtle' size='md' onClick={handleOnGoBack}>
          Take me back to the previous page
        </Button>
        <Button variant='subtle' size='md' onClick={handleGoLogin}>
          Take me back to the login page
        </Button>
      </Group>
    </Container>
  );
};

export default SocialLoginError;
